import { SiteUrls } from '@tableau/shared-urls';
import { CheckBoxWidget } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import { classes } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';
import { ContentLineageRelationshipInfo } from '~src/ts/models/ContentLineageRelationshipInfo';

import { LinkedTaskCellStyles } from '../styles/LinkedTaskCellStyles';
import { renderPrimaryFlowItem } from './flows/SelectFlowCell';

const handleCheckboxClick = (e: React.SyntheticEvent<HTMLInputElement, Event>) => {
  // let handleCellClick handle click events
  e.preventDefault();
};

export function ContentLineageRelationshipCell(isSelected: (id: string) => boolean, onItemSelectionToggle: (row: DataGrid.Row) => void, siteUrls: SiteUrls): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
    function ContentLineageRelationshipCell(props: BodyCell.Props) {
      const lineageContentRelationship: ContentLineageRelationshipInfo= props.row.data as ContentLineageRelationshipInfo;
      const isDisabled: boolean = !lineageContentRelationship.userHasRunPermissions;

      const handleCellClick = (e: React.SyntheticEvent<HTMLDivElement, Event>) => {
        if (!isDisabled) {
          onItemSelectionToggle(props.row);
        }
        e.preventDefault();
        e.stopPropagation();
      };

      const relatedContentNames = lineageContentRelationship.relatedContent ? lineageContentRelationship.relatedContent.map((item) => item.relatedContentName) : [];
      const relatedContentText = relatedContentNames.join(', ');

      function renderRelatedContent() {
        return relatedContentText ? (
          <div className={classes(LinkedTaskCellStyles.InnerTextWrapper, isDisabled ? LinkedTaskCellStyles.Disabled : null)}>
            <div className={classes(LinkedTaskCellStyles.FlexShrinkZero, LinkedTaskCellStyles.ContentItem)}>
              {lineageContentRelationship.lineageRelationshipType === 'Downstream' ? Messages.linkedTasksDownstreamOf() : Messages.linkedTasksUpstreamOf()}
            </div>
            <div className={classes(LinkedTaskCellStyles.ContentItem, LinkedTaskCellStyles.ContentName)} title={relatedContentText}>
              {relatedContentText}
            </div>
          </div>
        ) : null;
      }

      return lineageContentRelationship.content ? (
        /* eslint-disable jsx-a11y/no-static-element-interactions */
        /* eslint-disable jsx-a11y/click-events-have-key-events */
        <div
          onClick={handleCellClick}
          key={lineageContentRelationship.content.id}
          className={LinkedTaskCellStyles.Wrapper}
          data-tb-test-id={'ContentLineageRelationshipCellTestId'}
        >
          <div className={LinkedTaskCellStyles.CheckboxWrapper}>
            <CheckBoxWidget
              checked={isSelected(lineageContentRelationship.content.id)}
              handleChange={() => onItemSelectionToggle(props.row)}
              testId={'ContentLineageRelationshipCellCheckboxTestId'}
              removeLeftMargin={true}
              disabled={isDisabled}
              onClick={handleCheckboxClick}
            />
          </div>
          <div className={LinkedTaskCellStyles.TextWrapper}>
            {renderPrimaryFlowItem(lineageContentRelationship.content.name, lineageContentRelationship.content.id, isDisabled, siteUrls)}
            {renderRelatedContent()}
          </div>
        </div>
      ) : null;
    }
  );
}
